import { render, staticRenderFns } from "./DelkoitHtsPage.vue?vue&type=template&id=07d0a252&scoped=true"
import script from "./DelkoitHtsPage.vue?vue&type=script&lang=js"
export * from "./DelkoitHtsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d0a252",
  null
  
)

export default component.exports